import React, { useState, useEffect } from "react";
import slide1 from "../../images/hero/slide1.webp";
import slide2 from "../../images/hero/slide2.webp";
import slide3 from "../../images/hero/slide3.webp";
import slide4 from "../../images/hero/slide4.webp";

import "./home-images.css";
export default function HomeImagesSection() {
	const slides = [slide1, slide2, slide3, slide4];
	const [currentSlide, setCurrentSlide] = useState(0);
	useEffect(() => {
		const intervalId = setInterval(() => {
			setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
		}, 5000);

		return () => clearInterval(intervalId);
	}, [slides.length]);

	useEffect(() => {
		const homePreviewImages = document.querySelector(".home-preview-images");
		const mainImages = document.querySelector(".main-images");

		const heightIm = mainImages.offsetHeight;
		var prevSlide = 0;
		if (currentSlide == 0) {
			prevSlide = 3;
		} else {
			prevSlide = currentSlide - 1;
		}
		homePreviewImages.style.backgroundImage = `url(${slides[prevSlide]})`;

		mainImages.style.opacity = 1;

		setTimeout(() => {
			homePreviewImages.style.backgroundImage = `url(${slides[currentSlide]})`;
			mainImages.style.opacity = 0;
		}, 2500);
	}, [currentSlide, slides]);

	return (
		<div className="home-preview-images">
			<h1 className="hero-title">
				<span>
					Unternehmensberatung für
					<br />
					die Immobilienwirtschaft.
				</span>
			</h1>
			<div
				className="main-images"
				style={{ backgroundImage: "url(" + slides[currentSlide] + ")" }}
				alt={`Slide ${currentSlide + 1}`}
			/>
		</div>
	);
}
